export const OIDC_CONSTS = {
  moduleName: 'oidc',

  getters: {
    oidcIsAuthenticated: 'oidcIsAuthenticated',
  },
  actions: {
    oidcSignInCallback: 'oidcSignInCallback',
    signOutOidc: 'signOutOidc',
    removeOidcUser: 'removeOidcUser',
  },
}
